import { Fragment, useEffect, useState, useRef } from "react";

import "./character.css";
import finalchapterbase from "./finalchapter/Finalefrontcover.jpg";
const FinalChapFront = (props) => {
    return (
        <Fragment >
            <div className="chapter_final_front_cover height">
                <img src={finalchapterbase} />
                <div className="chapterfinalcustomimage">
                    {props.children}
                </div>
            </div>
        </Fragment>
    )
}
export default connect(FinalChapFront);